import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs/Rx";
import { GlobalService } from "../../_global/global.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _userService: UserService, private _gs: GlobalService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        if (sessionStorage.getItem('currentUser')) {
            this._gs.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
            return true;
        }
        else {
            this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_guards/auth.guard.ts